import {mountDataComponents} from '@/utils/mount';
import '@/blocks/hero-slider.js';
import '@/blocks/home-special-offers.js';
import '@/blocks/destinations.js';
import '@/blocks/child-destinations.js';
import '@/blocks/social-media.js';
import '@/blocks/book-online.js';
import '@/blocks/holiday-list.js';
import '@/blocks/property-hero.js';
import '@/blocks/property-overview.js';
import '@/blocks/property-facilities.js';
import '@/blocks/property-rooms.js';
import '@/blocks/book-form.js';
import '@/blocks/scroll-top.js';
import '@/blocks/manage-booking-signin.js';
import '@/blocks/manage-booking.js';

const shell = document.querySelector('[data-shell]');
const menuButton = shell?.querySelector('[data-menu-toggle]');
const desktopQuery = window.matchMedia('(min-width: 1001px)');
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
let menuSlide = null;

function withMenuSlide(direction, change) {
    const canSlide = !desktopQuery.matches
        && !reducedMotionQuery.matches
        && typeof document.startViewTransition === 'function';

    if (!canSlide) {
        change();
        return;
    }

    menuSlide?.skipTransition();
    document.documentElement.dataset.menuSlide = direction;

    let applied = false;
    try {
        const transition = document.startViewTransition(() => {
            applied = true;
            change();
        });
        menuSlide = transition;
        transition.finished.finally(() => {
            if (menuSlide === transition) {
                menuSlide = null;
                delete document.documentElement.dataset.menuSlide;
            }
        });
    } catch {
        if (menuSlide === null) {
            delete document.documentElement.dataset.menuSlide;
        }
        if (!applied) {
            change();
        }
    }
}

function closeItem(item) {
    item.classList.remove('is-open');
    const toggle = item.querySelector(':scope > [data-submenu-toggle]');
    if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
    }
    item.querySelectorAll('.is-open').forEach((nested) => {
        nested.classList.remove('is-open');
        const nestedToggle = nested.querySelector(':scope > [data-submenu-toggle]');
        if (nestedToggle) {
            nestedToggle.setAttribute('aria-expanded', 'false');
        }
    });
}

function setMenuIcon(open) {
    shell.querySelector('[data-menu-icon="open"]')?.toggleAttribute('hidden', open);
    shell.querySelector('[data-menu-icon="close"]')?.toggleAttribute('hidden', !open);
}

function setMenuOpen(open) {
    if (!menuButton || desktopQuery.matches) {
        return;
    }
    shell.classList.toggle('is-menu-open', open);
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuButton.setAttribute('aria-label', open ? 'Close' : 'Menu');
    setMenuIcon(open);
    if (!open) {
        shell.querySelectorAll('.site-nav__item.is-open').forEach(closeItem);
    }
}

if (menuButton && shell) {
    menuButton.addEventListener('click', () => {
        setMenuOpen(menuButton.getAttribute('aria-expanded') !== 'true');
    });

    shell.addEventListener('click', (event) => {
        const back = event.target.closest('[data-submenu-back]');
        if (back) {
            const item = back.closest('.site-nav__item');
            if (item) {
                withMenuSlide('back', () => closeItem(item));
                item.querySelector(':scope > [data-submenu-toggle]')?.focus();
            }
            return;
        }

        const toggle = event.target.closest('[data-submenu-toggle]');
        if (!toggle || !shell.contains(toggle)) {
            return;
        }

        const item = toggle.parentElement;
		const topLevel = item?.parentElement?.parentElement?.classList.contains('site-nav');
		if (!topLevel && desktopQuery.matches) {
			return;
		}
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        withMenuSlide(open ? 'forward' : 'back', () => {
            const list = item?.parentElement;
            list?.querySelectorAll(':scope > .site-nav__item.is-open').forEach((sibling) => {
                if (sibling !== item) {
                    closeItem(sibling);
                }
            });
            item?.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }
		const openItems = [...shell.querySelectorAll('.site-nav__item.is-open')];
		const openItem = desktopQuery.matches ? openItems[0] : openItems.at(-1);
        if (openItem) {
            const toggle = openItem.querySelector(':scope > [data-submenu-toggle]');
            withMenuSlide('back', () => closeItem(openItem));
            toggle?.focus();
            return;
        }
        if (menuButton.getAttribute('aria-expanded') === 'true') {
            setMenuOpen(false);
            menuButton.focus();
        }
    });

	document.addEventListener('click', (event) => {
		if (!desktopQuery.matches) {
			return;
		}
		const nav = shell.querySelector('[data-menu]');
		if (!nav || nav.contains(event.target)) {
			return;
		}
		nav.querySelectorAll(':scope > .site-nav__list > .site-nav__item.is-open').forEach(closeItem);
	});

    desktopQuery.addEventListener('change', () => {
        if (desktopQuery.matches) {
            shell.classList.remove('is-menu-open');
            menuButton.setAttribute('aria-expanded', 'false');
            menuButton.setAttribute('aria-label', 'Menu');
            setMenuIcon(false);
        }
    });
}

mountDataComponents();

if (document.documentElement.dataset.rumSample) {
    import('@/web-vitals').then(({startWebVitals}) => startWebVitals());
}
